import { CampanhaSearch } from '../../campanha-search';
import { CampanhaSearchViewTotal } from '../../campanha-search-view-total';
import { sumResultado, subResultado, CampanhaResultado } from '../../resultado';

export class CampanhaPipelineListTotal {
    private total: CampanhaSearchViewTotal;

    constructor(total: CampanhaSearchViewTotal) {
        this.total = total;
    }

    get quantidadeCampanhas(): number {
        return this.total.quantidadeCampanhas;
    }

    get resultado(): CampanhaResultado {
        return this.total.resultado;
    }

    /** Adiciona os valores da campanha informado dos totais da list */
    addEntity(entity: CampanhaSearch, roiPontoEquilibrio: number) {
        if (!entity) {
            return;
        }

        this.total.quantidadeCampanhas++;
        this.total.resultado = sumResultado(this.total.resultado, entity.resultado, roiPontoEquilibrio);
    }

    /** Remove os valores da campanha informada dos totais da list */
    removeEntity(entity: CampanhaSearch, roiPontoEquilibrio: number) {
        if (!entity) {
            return;
        }

        this.total.quantidadeCampanhas--;
        this.total.resultado = subResultado(this.total.resultado, entity.resultado, roiPontoEquilibrio);
    }
}
